module.exports = {
	"indiv": "Individual/sole proprietor or single-member LLC",
	"c_corp": "C Corporation",
	"s_corp": "S Corporation",
	"partner": "Partnership",
	"trust": "Trust/estate",
	"llc": "Limited liability company"
};


//////////////////
// WEBPACK FOOTER
// ./src/js/data/taxClassifications.json
// module id = 5
// module chunks = 0